module.exports = __webpack_public_path__ + "static/media/01_marius_hirschel_cornelius_carstens.d481fc1.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/mh/01_marius_hirschel_cornelius_carstens.mp4
// module id = 3hVD
// module chunks = 1